"use strict";

/* globals app, socket */

(function() {
	requirejs([
		'components', 'benchpress'
	], function(components, Benchpress) {
		Benchpress.registerHelper('connectBestanswerButtonVisible', function(data, iterator, blocks) {
			console.log("P1")
			console.log(data.selfPost)
		    return (data.selfPost == false) ? '' : 'hidden';
		});
		Benchpress.registerHelper('connectThanksButtonVisible', function(data, iterator, blocks) {
			console.log("P2")
			console.log(data);
		    return '';//return (!data.selfPost) ? '' : 'hidden';
		});
		console.log("YYY0");
		$(window).on('action:ajaxify.end', function(ev, data) {
			init(components);
		});
		$(window).on('action:topics.loaded', function() {
			init(components);
		});
	});

	socket.on('event:bestanswer', onEventBestanswer);
	socket.on('event:thanked', onEventThanks);

	function onEventBestanswer(data) {
		updateBestanswer(data);
	}

	function onEventThanks(data) {
		updateThanks(data);
	}

	/*
	 * Per Best Answer and Thanks
	 */
	function getData(button, data) {
		return button.parents('[data-pid]').attr(data);
	}

	function bestanswerPost(button, pid, tid) {
		if(button.data('bestsel')) {
			var action = "unbestanswer"
		} else {
			var action = "bestanswer"
		}
		socket.emit('plugins.connectPostInteractionsExtends.bestanswer', {
			pid: pid,
			room_id: app.currentRoom,
			action: action
		}, function(err, data) {
			if (err) {
				app.alertError(err.message);
			} else {
				updateBestanswer(data);
			}
		});

		return false;
	}

	function updateBestanswer(data) {
		var thanksBtn = $('[data-pid="' + data.post.pid + '"] [component="post/bestanswer"]');

		if (!thanksBtn.length) {
			return;
		}

		thanksBtn.data('bestanswer', data.isBestanswer);
		thanksBtn.data('bestsel', data.isBestanswer);

		thanksBtn.find('[component="post/bestanswer/on"]').toggleClass('hidden', !data.isBestanswer);
		thanksBtn.find('[component="post/bestanswer/off"]').toggleClass('hidden', data.isBestanswer);
	}

	function thanksPost(button, pid) {
		if(button.data('thanked')) {
			var action = "unthanks"
		} else {
			var action = "thanks"
		}
		socket.emit('plugins.connectPostInteractionsExtends.thanks', {
			pid: pid,
			room_id: app.currentRoom,
			action: action
		}, function(err, data) {
			if (err) {
				app.alertError(err.message);
			} else {
				updateThanks(data);
			}
		});

		return false;
	}

	function updateThanks(data) {
		var thanksBtn = $('[data-pid="' + data.post.pid + '"] [component="post/thanks"]');

		if (!thanksBtn.length) {
			return;
		}
		thanksBtn.data('thanked', data.post.thanks);
		thanksBtn.find('[component="post/thanks/on"]').toggleClass('hidden', !data.isThanks);
		thanksBtn.find('[component="post/thanks/off"]').toggleClass('hidden', data.isThanks);
		thanksBtn.find('[component="post/thanks-count"]').attr('data-thanks', data.post.thanks).html(data.post.thanks);
	}

	function init(components) {
		var postContainer = components.get('topic');
		postContainer.off('click', '[component="post/bestanswer"]').on('click', '[component="post/bestanswer"]', function() {
			return bestanswerPost($(this), getData($(this), 'data-pid'));
		});

		postContainer.off('click', '[component="post/thanks"]').on('click', '[component="post/thanks"]', function() {
			return thanksPost($(this), getData($(this), 'data-pid'));
		});
	}
}());
